<template>
  <div>
    <vx-card>
      <div id="data-list-list-view" class="data-list-container">
        <vs-table
          noDataText="Nenhuma Pre Cotação Encontrada"
          class="tablePrincipal"
          ref="table"
          multiple
          v-model="selected"
          :data="itens"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between"
          >
            <div class="flex flex-wrap-reverse items-center">
              <!------------- COMEÇO ADICIONAR NOVA PRE COTACÃO-------------->
              <router-link
                v-if="$can($actionsDefault.Escrita, subjectPermission)"
                to="novaPreCotacao"
              >
                <div
                  class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                >
                  <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                  <span class="ml-2 text-base text-primary"
                    >Nova Pré Cotação</span
                  >
                </div>
              </router-link>

              <!------------- FINAL ADICIONAR NOVA PRE COTACÃO ----------------->
            </div>

            <!------------ COMEÇO ITENS POR PAGINA ----------->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2">{{ de }} - {{ ate }} de {{ total }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage = 5">
                  <span>5</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 50">
                  <span>50</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
            <!-------------FINAL ITENS POR PAGINA ------------>
          </div>

          <!------------ COMEÇO TITULO DA TABELA ------------>
          <template slot="thead">
            <vs-th sort-key="nome">Nome</vs-th>
            <vs-th sort-key="celular">Celular</vs-th>
            <vs-th sort-key="placa">Placa</vs-th>
            <vs-th sort-key="marcaModelo">Marca/Modelo</vs-th>
            <vs-th sort-key="grupo">Grupo</vs-th>
            <vs-th sort-key="valor">Valor</vs-th>
            <vs-th>Ações</vs-th>
          </template>
          <!------------ FIM DO TITULO DA TABELA ------------>

          <!-- ----------COMEÇO DA PRE COTAÇÃO----------- -->
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="product-category">{{ tr.nome }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{ tr.celular }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{ tr.placa }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{ MarcaModelo(tr) }}</p>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{ tr.jsonRetorno.grupoSeleciondo.label }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{
                      tr.valor.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })
                    }}
                  </p>
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <div class="vx-col" v-if="!tr.idPropostaConvertida">
                      <router-link
                        :to="`/novaProposta/Interno?idPreCotacao=${tr.idPreCotacao}`"
                      >
                        <vs-button
                          v-tooltip="'Converter em Cotação'"
                          radius
                          color="success"
                          type="gradient"
                          icon-pack="feather"
                          icon="icon-edit"
                          class="d-inline"
                        ></vs-button>
                      </router-link>
                    </div>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
          <!-- ----------FIM DA PRE COTAÇÃO------------- -->
        </vs-table>
        <vs-pagination
          :total="qtdPaginas"
          v-model="paginaAtual"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>
<script>
import service from '../../services/index';
import moment from 'moment';
import jwt from 'jsonwebtoken';

export default {
  props: ['subjectPermission', 'filtros', 'realizarFiltro'],
  data() {
    return {
      idEmpresa: null,
      selected: [],
      itens: [],
      itemsPerPage: 5,
      paginaAtual: 1,
      qtdTotal: 0,
      qtdPaginas: 0,
      fazerBuscaCotacoes: true,
    };
  },
  watch: {
    realizarFiltro: function (newValue, oldValue) {
      if (newValue && !oldValue) {
        this.definirPaginaAtualPrimeira();
        this.buscarCotacoes();
        this.$emit('finalizarFiltros');
      }
    },
    paginaAtual: function (/*newValue, oldValue*/) {
      this.fazerBuscaCotacoes && this.buscarCotacoes();
      this.atribirTrueFazerBuscaCotacoes();
    },
    itemsPerPage: function (/*newValue, oldValue*/) {
      this.corrigirPaginacao();
      this.buscarCotacoes();
    },
  },
  computed: {
    de() {
      return this.paginaAtual * this.itemsPerPage - (this.itemsPerPage - 1);
    },
    ate() {
      return (
        this.paginaAtual * this.itemsPerPage -
        this.itemsPerPage +
        this.itens.length
      );
    },
    total() {
      return this.qtdTotal;
    },
  },
  methods: {
    buscaDadosToken() {
      const token = localStorage.getItem('user-token');
      if (token) {
        const decoded = jwt.decode(token);
        this.idEmpresa = decoded.id_empresa;
      }
    },
    buscarCotacoes() {
      this.$vs.loading();
      let objSend = {};
      if (this.filtros) {
        objSend = { ...this.filtros };
        objSend.dataInicial = moment(this.filtros.dataInicial).format(
          'YYYY-MM-DD',
        );
        objSend.dataFinal = moment(this.filtros.dataFinal).format('YYYY-MM-DD');
      } else {
        objSend.dataInicial = moment().add(-30, 'days').format('YYYY-MM-DD');
        objSend.dataFinal = moment().format('YYYY-MM-DD');
      }
      objSend.pagina = this.paginaAtual;
      objSend.qtdPorPagina = this.itemsPerPage;

      service
        .post('PreCotacao', 'buscarPreCotacao', objSend)
        .then((res) => {
          this.itens = [];
          this.itens = res.data.resultado;
          this.redefinirPaginacao(res.data);
          this.qtdTotal > 0 && this.redefinirPagainaAtual();
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    MarcaModelo(cotacao) {
      if (cotacao.jsonRetorno.dadosPlaca) {
        return cotacao.jsonRetorno.dadosPlaca.marcaModelo;
      }
    },
    redefinirPaginacao(data) {
      this.qtdTotal = data.qtdTotal;
      this.qtdPaginas = data.qtdTotal / this.itemsPerPage;
      if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
      this.qtdPaginas = parseInt(this.qtdPaginas);
    },
    corrigirPaginacao() {
      if ((this.paginaAtual - 1) * this.itemsPerPage > this.total) {
        this.fazerBuscaCotacoes = false;
        this.paginaAtual = Math.ceil(this.qtdTotal / this.itemsPerPage);
      }
    },
    redefinirPagainaAtual() {
      if (this.paginaAtual > this.qtdPaginas) {
        this.fazerBuscaCotacoes = false;
        this.paginaAtual = this.qtdPaginas;
      }
    },
    definirPaginaAtualPrimeira() {
      if (this.paginaAtual !== 1) {
        this.fazerBuscaCotacoes = false;
        this.paginaAtual = 1;
      }
    },
    atribirTrueFazerBuscaCotacoes() {
      this.fazerBuscaCotacoes = true;
    },
  },
  created() {
    this.buscaDadosToken();
    this.buscarCotacoes();
  },
  mounted() {},
};
</script>
<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.vs-button.includeIcon {
  float: left;
  margin-right: 5px;
}

.vs-chip-bg-pink {
  background-color: rgb(255, 68, 0);
}

.vs-chip-bg-blue {
  background-color: navy;
}
</style>
<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
</style>
